







































































import Vue from "vue";
import { mapActions, mapState } from "vuex";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
  },
  inject: ["actionHandler"],
  methods: {
    handleRowItemClick(event: Event) {
      (this as any).actionHandler("rowselect", (this as any).row);
    },
    markVisit(value: boolean) {
      (this as any).actionHandler("markVisit", {
        type: value,
        data: (this as any).row,
      });
    },
  },
});
